class SeasonSettingsProvider {
    /**
     * Fetch season settings from a remote source.
     *
     * @param {string} seasonId
     * @returns {Promise<{ ruleSetId?: string, gameConfiguration?: object, updatedAt?: string }|null>}
     *   Return null if no remote settings exist.
     *   Include `updatedAt` (ISO 8601) so the library can determine which version is newer.
     *   When `updatedAt` is omitted, remote settings are always applied.
     */
    async getSettings(seasonId) {
        return null;
    }

    /**
     * Persist season settings to a remote source.
     *
     * @param {string} seasonId
     * @param {{ ruleSetId?: string, gameConfiguration?: object, updatedAt: string }} settings
     *   `updatedAt` is always provided — store it alongside the settings so future
     *   calls to `getSettings` can return it for timestamp comparison.
     */
    async saveSettings(seasonId, settings) {}
}

export default SeasonSettingsProvider;
